module.exports = __webpack_public_path__ + "static/media/companyIntroImg_1.b1688c78.png";